<template>
  <el-dialog
    :model-value="dialogVisible"
    title="考前说明"
    :width="720"
    custom-class="before_exam_dialog"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="top_tab">
      <span
        :class="{ active: map.tab === 1 }"
        @click="viewExamInfo"
      >考前说明</span>
      <span
        :class="{ active: map.tab === 2 }"
        @click="viewExamRecord"
      >考试记录</span>
      <!--      <span :class="{ active: map.tab === 3 }" @click="viewExamLog">考试排名</span>-->
    </div>
    <div
      class="close_icon"
      @click="handleClose"
    >
      <el-icon><close /></el-icon>
    </div>
    <div
      v-loading="ctrl.loading"
      class="content"
    >
      <template v-if="map.tab === 1">
        <div class="examName">
          {{ examName }}
        </div>
        <div class="flex_table_box">
          <div class="info_item">
            <div>题目数：共{{ map.info.titleCount }}大题，共{{ map.info.questionCount }}题</div>
          </div>
          <div class="info_item">
            <div>考试限时：</div>
            <span>{{ map.info.answerTime }}分钟</span>
          </div>
          <div class="info_item">
            <div>试卷总分：{{ map.info.score }}分</div>
          </div>
          <div class="info_item">
            <div>合格分数：{{ map.info.passScore }}分合格</div>
          </div>

          <div class="info_item">
            <div>剩余考试次数：</div>
            <span>{{
              !map.info.startExam
                ? "0次"
                : map.info.examCount === 0
                  ? "不限"
                  : map.info.examCount + "次"
            }}</span>
          </div>
          <div class="info_item">
            <div>出卷规则：</div>
            <span>{{ map.info.randomCombine?'随机组卷':'人工组卷' }}</span>
          </div>
          <div class="info_item">
            <div>评阅方式：</div>
            <span>{{ map.info.correctWay === 1 ?'系统评阅':'人工评阅' }}</span>
          </div>
          <div class="info_item">
            <div />
          </div>
        </div>
        <div
          v-if="map.info.switchScreenLimitSet"
          class="tip_item"
        >
          <span>本场考试已开启防切屏，{{ map.info.switchScreenLimit === 0 ?'禁止切屏，切屏后将自动交卷' :`切屏${map.info.switchScreenLimit}次后将自动交卷` }}，答题过程中请勿切屏及刷新页面！</span>
        </div>
      </template>
      <div
        v-if="map.tab === 2"
        class="record_list"
      >
        <el-table
          height="380px"
          class="border_table"
          :data="map.list"
          cell-class-name="cellName"
          header-cell-class-name="border_cell_name"
        >
          <el-table-column
            type="index"
            label="序号"
          />
          <el-table-column
            prop="submitTime"
            label="交卷时间"
            width="160"
          >
            <template #default="scope">
              {{ scope.row.submitTime || scope.row.endTime }}
            </template>
          </el-table-column>
          <el-table-column
            label="答题用时"
            width="95"
          >
            <template #default="scope">
              {{ formatDuring(scope.row.answerTime * 1000) }}
            </template>
          </el-table-column>
          <el-table-column label="阅卷状态">
            <template #default="scope">
              <div
                class="bg_dog"
                :class="{success:scope.row.examStatus !== 2,error:scope.row.examStatus === 2}"
              >
                <template v-if="scope.row.examStatus === 2">
                  待阅卷
                </template>
                <template v-else-if="scope.row.examStatus === 3">
                  批阅中
                </template>
                <template v-else-if="scope.row.examStatus === 1">
                  考试中
                </template>
                <template v-else>
                  已阅卷
                </template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="考试结果">
            <template #default="scope">
              {{ scope.row.passStatus == 1 ? "及格" : "不及格" }}
            </template>
          </el-table-column>
          <el-table-column
            label="考试成绩"
            prop="userScore"
          />
          <el-table-column
            label="操作"
            fixed="right"
          >
            <template #default="scope">
              <el-button
                v-if="scope.row.examStatus === 1"
                type="text"
                @click="continuteExam(scope.row)"
              >
                进入考试
              </el-button>
              <el-button
                v-else
                type="text"
                @click="handleCheckReport(scope.row)"
              >
                查看报告
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        v-if="map.tab === 3"
        class="record_list"
      >
        <el-table
          height="380px"
          class="border_table"
          :data="map.rankList"
          cell-class-name="cellName"
          header-cell-class-name="border_cell_name"
        >
          <el-table-column label="排行">
            <template #default="scope">
              {{ scope.$index }}
            </template>
          </el-table-column>
          <el-table-column label="用户头像/昵称">
            <template #default="scope">
              <div class="user_info">
                <img :src="scope.row.nickname">
                <span>{{ scope.row.nickname }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="手机号"
            prop="phone"
          >
            <template #default="scope">
              +{{ scope.row.telCode }}-{{ scope.row.phone }}
            </template>
          </el-table-column>
          <el-table-column
            label="成绩分数"
            prop="userScore"
          />
          <el-table-column label="答题用时">
            <template #default="scope">
              {{ formatDuring(scope.row.answerTime * 1000) }}
            </template>
          </el-table-column>
          <el-table-column label="开始考试时间" />
        </el-table>
      </div>
    </div>
    <template #footer>
      <span
        v-if="map.tab === 1"
        class="dialog-footer"
      >
        <el-button
          plain
          size="large"
          @click="handleClose()"
        >取消</el-button>
        <el-button
          v-if="!map.info.faceRecognition"
          size="large"
          type="primary"
          @click="handleGoToExam()"
        >进入考试</el-button>
        <el-button
          v-else
          size="large"
          type="primary"
          @click="handleOpenFace"
        >人脸识别</el-button>

      </span>
      <div
        v-if="map.tab === 2"
        class="pagination"
      >
        <el-pagination
          v-model:currentPage="page.pageCurrent"
          v-model:pageSize="page.pageSize"
          background
          layout="total, prev, pager, next, jumper"
          :total="page.totalCount"
          @current-change="handleCurrentChange"
        />
      </div>
    </template>
    <course-sign
      ref="courseSign"
      :course-info="signInfo"
      :biz-type="bizType"
      :player="{}"
      @succeed="map.info.faceRecognition = true"
    />
  </el-dialog>
</template>

<script>
import { paperExamInfo, paperRecordPage } from '@/api/paper.js'
import { defineComponent, ref, toRefs, reactive } from 'vue'
import { setStore } from '@/utils/storage'
import { formatDuring } from '@/utils/index'
import { ElMessage } from 'element-plus'
import { examRecordRank } from '../../api/paper'
import { Close } from '@element-plus/icons-vue'
export default defineComponent({
  components: { Close },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    paperId: {
      type: String,
      default: () => {
        return ''
      }
    },
    resourceId: {
      type: String,
      default: () => {
        return ''
      }
    },
    resourceType: {
      type: Number,
      default: () => {
        return 1
      }
    },
    examType: {
      type: Number,
      default: 2
    },
    examName: {
      type: String,
      default: () => {
        return ''
      }
    },
    chapterId: {
      type: String,
      default: () => {
        return ''
      }
    },
    periodId: {
      type: String,
      default: () => {
        return ''
      }
    },
    singleCourseId: {
      type: String,
      default: () => {
        return ''
      }
    },
    tabType: {
      type: Number,
      default: 1
    },
    bizType: {
      type: Number,
      default: 1
    }
  },
  emits: ['close'],
  setup (props, { emit }) {
    const loading = ref(false)
    const courseSign = ref(null)
    const router = useRouter()
    const {
      dialogVisible,
      paperId,
      resourceId,
      resourceType,
      chapterId,
      periodId,
      examType,
      singleCourseId,
      tabType,
      bizType
    } = toRefs(props)
    const map = reactive({
      info: {},
      tab: 1,
      list: [],
      rankList: []
    })
    const ctrl = reactive({
      loading: false,
      sign: false
    })
    const signInfo = reactive({
      id: '',
      chapterId: '',
      periodId: ''
    })
    const page = reactive({
      totalCount: 0,
      pageCurrent: 1,
      pageSize: 30
    })
    const viewExamLog = () => {
      map.tab = 3
      const d = {
        examType: examType.value,
        relationalId: resourceId.value,
        relevanceType: 1 // 1:课程关联、2:专题关联
      }
      if (chapterId.value && periodId.value) {
        d.relevanceType = 2
      }
      ctrl.loading = true
      examRecordRank(d).then((res) => {
        map.rankList = res.rankList || []
        ctrl.loading = false
      })
        .catch((e) => {
          handleClose()
          ctrl.loading = false
        })
    }
    const viewExamRecord = () => {
      map.tab = 2
      const d = {
        pageCurrent: page.pageCurrent,
        pageSize: page.pageSize,
        paperId: paperId.value,
        examType: examType.value,
        relationalId: resourceId.value,
        relevanceType: 1 // 1:课程关联、2:专题关联
      }
      if (chapterId.value && periodId.value) {
        d.chapterId = chapterId.value
        d.periodId = periodId.value
        d.relevanceType = 2
      }
      ctrl.loading = true
      paperRecordPage(d)
        .then((res) => {
          page.pageCurrent = res.pageCurrent
          page.totalPage = res.totalPage
          page.totalCount = res.totalCount
          map.list = res.list || []
          ctrl.loading = false
        })
        .catch((e) => {
          handleClose()
          ctrl.loading = false
        })
    }
    const viewExamInfo = () => {
      map.tab = 1
      ctrl.loading = true
      const d = {
        paperId: paperId.value,
        relationalId: resourceId.value,
        resourceType: resourceType.value,
        examType: examType.value
      }
      if (chapterId.value && periodId.value) {
        d.chapterId = chapterId.value
        d.periodId = periodId.value
        d.courseId = singleCourseId.value
      }
      paperExamInfo(d)
        .then((res) => {
          map.info = res
          setStore('examInfoAndResult', {
            paperId: paperId.value,
            correctWay: map.info.correctWay,
            showAnswerRule: map.info.showAnswerRule,
            showAnswerInfo: map.info.showAnswerInfo,
            passScore: map.info.passScore,
            chapterId: chapterId.value,
            periodId: periodId.value,
            endTime: map.info.endTime,
            scoreRecordRule: map.info.scoreRecordRule,
            maxSwitchScreenLimit: map.info.switchScreenLimitSet ? res.switchScreenLimit : -1
          })
          ctrl.loading = false
        })
        .catch((e) => {
          handleClose()
          ctrl.loading = false
        })
    }
    const handleCurrentChange = (v) => {
      page.pageCurrent = v
      viewExamRecord()
    }
    const handleClose = () => {
      emit('close', false)
    }
    const handleOpenFace = () => {
      if (chapterId.value) { // 专题课
        signInfo.id = singleCourseId.value
        signInfo.chapterId = chapterId.value
        signInfo.periodId = periodId.value
      } else {
        signInfo.id = resourceId.value
      }
      if (bizType.value === 3) {
        delete signInfo.id
        delete signInfo.periodId
        delete signInfo.chapterId
        signInfo.paperId = resourceId.value
      }
      if (bizType.value === 5) {
        delete signInfo.id
        delete signInfo.periodId
        delete signInfo.chapterId
        signInfo.classroomExamId = resourceId.value
      }
      if (courseSign.value) {
        courseSign.value.init().then(() => {
          handleGoToExam()
        })
      }
    }

    const handleGoToExam = () => {
      if (!map.info.startExam) {
        ElMessage.error('考试次数已达到上限')
        return
      }
      emit('close', true)
    }

    const continuteExam = (row) => {
      emit('close', true)
    }

    if (dialogVisible.value) {
      if (tabType.value === 1) {
        viewExamInfo()
      }
      if (tabType.value === 2) {
        viewExamRecord()
      }
    }
    const handleGoExamResult = (row) => {
      router.push({
        path: '/exam/result',
        query: {
          type: 1
        }
      })
    }

    const handleCheckReport = (row) => {
      router.push({
        path: '/exam/result',
        query: {
          type: 3,
          examType: examType.value,
          recordId: row.id
        }
      })
    }
    return {
      loading,
      map,
      ctrl,
      page,
      signInfo,
      courseSign,
      formatDuring,
      handleGoToExam,
      continuteExam,
      handleOpenFace,
      handleClose,
      viewExamInfo,
      viewExamRecord,
      viewExamLog,
      handleCurrentChange,
      handleGoExamResult,
      handleCheckReport
    }
  }
})
</script>
<style lang="scss">
.before_exam_dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
  .el-dialog__headerbtn {
    top: 1px;
  }
  .el-dialog__footer {
    text-align: center;
    padding-top: 14px;
    padding-bottom: 14px;
    border-top: 1px solid #EBEEF5;
    .el-button{
      width: 80px;
      height: 32px;
      border-radius: 4px;
    }
  }
}
</style>
<style lang="scss" scoped>
.top_tab {
  position: relative;
  top: 0;
  width: 100%;
  padding: 14px 0;
  border-bottom: 1px solid #ebeef5;
  span {
    color: #333;
    margin: 0 15px;
    font-size: 16px;
    cursor: pointer;
  }
  .active {
    color: #3D7FFF;
    position: relative;
  }
  .active:before{
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    bottom: -16px;
    background: #3D7FFF;
  }
}
.content {
  padding: 20px 25px;
  border-radius: 5px;
  .examName{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    background: linear-gradient(90deg, #3D7FFF 0%, rgba(61, 127, 255, 0.8) 100%);
    box-shadow: inset 0px -1px 0px #EBEEF5;
  }
}
.flex_table_box{
  display: flex;
  flex-wrap: wrap;
  .info_item {
    width: 50%;
    height: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #EBEEF5;;
    color: #333;
    &:nth-child(n+1){
      border-top: 0;
    }
    &:nth-last-child(1){
      border-bottom-right-radius: 5px;
    }
    &:nth-last-child(2){
      border-bottom-left-radius: 5px;
    }
    &:nth-child(even){
      border-left: 0;
    }
    img {
      width: 24px;
      height: 24px;
    }
  }
}

.tip_item {
  margin-top: 14px;
  margin-bottom: 63px;
  text-align: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    display: inline-block;
  }
  span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ff9d00;
  }
}
.record_list {
  height: 380px;
  overflow-y: auto;
}
.record_item {
  position: relative;
  border-bottom: 1px solid #ebeef5;
  .border {
    background: #becadb;
    display: inline-block;
    height: 10px;
    margin: 0 10px;
    width: 1px;
  }
  p {
    &:nth-child(1) {
      margin-top: 20px;
    }
    &:nth-child(2) {
      color: #999;
      margin-top: 16px;
    }
    &:nth-child(3) {
      color: #999;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  &:first-child {
    p {
      &:nth-child(1) {
        margin-top: 0px;
      }
    }
  }
}
.status {
  position: absolute;
  right: 5px;
  top: 0;
}
.pass {
  color: #58b85c;
}
.unpass {
  color: #f61818;
}
.wait {
  color: #ff9d00;
}
.pagination {
  text-align: center;
}
.border_table{
  border: 1px solid #EBEEF5;
  border-bottom: 0;
}
.bg_dog{
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  &.success:before{
    color: #6FCF97;
  }
  &.error:before{
    color: #F23C3C;
  }
  &:before{
    content: '●';
    padding-right: 6px;
  }
}
.close_icon{
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  .el-icon{
    font-size: 24px;
  }
}
</style>
